import { tryUseNuxtApp } from '#app';

/**
 * Builds the `X-SSR-Cache` opt-in headers for a call that passed `ssrCache: true` — spread the result
 * into the call's headers, never set the header by hand. The header is only emitted during SSR, and its
 * value is a server-only nonce, so a browser can never produce a header the proxy will accept.
 *
 * @example
 * ```ts
 * $fetch('/front-office/v1/products', {
 *   headers: {
 *     'X-Mid-Token': mid,
 *     ...useSsrCacheHeaders(ssrCache),
 *   },
 * });
 * ```
 */
export function useSsrCacheHeaders(ssrCache: boolean | undefined): Record<string, string> {
  // Server-only config, so the nonce is `undefined` on the client — the header can never be built there.
  const nonce = tryUseNuxtApp()?.ssrContext?.runtimeConfig?.SSR_CACHE_NONCE as string | undefined;

  return ssrCache && import.meta.server && nonce ? { 'X-SSR-Cache': nonce } : {};
}
